import OfferCard from './OfferCard'

export default OfferCard
